// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Stock_pageName__dsfE2"};